import { ChronicleFilenamesEnum, PlanningModeEnum } from "shared/enums/globalEnums";
import { GenericPlanningConfig } from "../shared/types";
import { FieldValues } from "react-hook-form";
import { computeDefaultValuesGeneric } from "../shared/computeDefaultValues";
import { FcrDEngagementFields } from "../shared/initialFields";

export const fcrDPlanningConfigurations: GenericPlanningConfig[] = [
  {
    name: "planning_soc_1",
    mode: PlanningModeEnum.soc_management,
    durationInMinutes: 120,
    targetSoc: 0.25,
  },
  {
    name: "planning_fcrd_up_1_160",
    mode: PlanningModeEnum.fingrid_fcrd,
    durationInMinutes: 160,
    engagementUpConst: 1.25,
    engagementDownConst: 0,
    chronicleFilename: ChronicleFilenamesEnum.fin_certification_fingrid_fcr_d_up_test_1_160min,
    defaultEngagementFieldMapping: [FcrDEngagementFields.lowDroop, "fcrd_up_engagement"],
  },
  {
    name: "planning_soc_2",
    mode: PlanningModeEnum.soc_management,
    durationInMinutes: 200,
    targetSoc: 0.78,
  },
  {
    name: "planning_fcrd_down_1_130",
    mode: PlanningModeEnum.fingrid_fcrd,
    durationInMinutes: 130,
    engagementUpConst: 0,
    engagementDownConst: 1.25,
    chronicleFilename: ChronicleFilenamesEnum.fin_certification_fingrid_fcr_d_down_test_1_130min,
    defaultEngagementFieldMapping: [FcrDEngagementFields.lowDroop, "fcrd_down_engagement"],
  },
  {
    name: "planning_soc_3",
    mode: PlanningModeEnum.soc_management,
    durationInMinutes: 110,
    targetSoc: 0.5,
  },
  {
    name: "planning_fcrd_up_2a_20",
    mode: PlanningModeEnum.fingrid_fcrd,
    durationInMinutes: 20,
    engagementUpConst: 0.1,
    engagementDownConst: 0,
    chronicleFilename: ChronicleFilenamesEnum.fin_certification_fingrid_fcr_d_up_test_2_20min,
    defaultEngagementFieldMapping: [FcrDEngagementFields.highDroop, "fcrd_up_engagement"],
  },
  {
    name: "planning_soc_4",
    mode: PlanningModeEnum.soc_management,
    durationInMinutes: 20,
    targetSoc: 0.5,
  },
  {
    name: "planning_fcrd_up_2b_20",
    mode: PlanningModeEnum.fingrid_fcrd,
    durationInMinutes: 20,
    engagementUpConst: 1.25,
    engagementDownConst: 0,
    chronicleFilename: ChronicleFilenamesEnum.fin_certification_fingrid_fcr_d_up_test_2_20min,
    defaultEngagementFieldMapping: [FcrDEngagementFields.lowDroop, "fcrd_up_engagement"],
  },
  {
    name: "planning_soc_5",
    mode: PlanningModeEnum.soc_management,
    durationInMinutes: 20,
    targetSoc: 0.5,
  },
  {
    name: "planning_fcrd_down_2a_20",
    mode: PlanningModeEnum.fingrid_fcrd,
    durationInMinutes: 20,
    engagementUpConst: 0,
    engagementDownConst: 0.1,
    chronicleFilename: ChronicleFilenamesEnum.fin_certification_fingrid_fcr_d_down_test_2_20min,
    defaultEngagementFieldMapping: [FcrDEngagementFields.highDroop, "fcrd_down_engagement"],
  },
  {
    name: "planning_soc_6",
    mode: PlanningModeEnum.soc_management,
    durationInMinutes: 20,
    targetSoc: 0.5,
  },
  {
    name: "planning_fcrd_down_2b_20",
    mode: PlanningModeEnum.fingrid_fcrd,
    durationInMinutes: 20,
    engagementUpConst: 0,
    engagementDownConst: 1.25,
    chronicleFilename: ChronicleFilenamesEnum.fin_certification_fingrid_fcr_d_down_test_2_20min,
    defaultEngagementFieldMapping: [FcrDEngagementFields.lowDroop, "fcrd_down_engagement"],
  },
  {
    name: "planning_soc_7",
    mode: PlanningModeEnum.soc_management,
    durationInMinutes: 60,
    targetSoc: 0.6,
  },
  {
    name: "planning_fcrd_up_3_80",
    mode: PlanningModeEnum.fingrid_fcrd,
    durationInMinutes: 80,
    engagementUpConst: 1.25,
    engagementDownConst: 0,
    chronicleFilename: ChronicleFilenamesEnum.fin_certification_fingrid_fcr_d_up_test_3_80min,
    defaultEngagementFieldMapping: [FcrDEngagementFields.lowDroop, "fcrd_up_engagement"],
  },
  {
    name: "planning_soc_8",
    mode: PlanningModeEnum.soc_management,
    durationInMinutes: 120,
    targetSoc: 0.5,
  },
  {
    name: "planning_fcrd_both_1_60",
    mode: PlanningModeEnum.fingrid_fcrd,
    durationInMinutes: 60,
    engagementUpConst: 1.04,
    engagementDownConst: 1.04,
    defaultEngagementFieldMapping: [FcrDEngagementFields.oneHourTestCapacity, null],
  },
];

export function computeDefaultValuesFcrD(initialData: FieldValues) {
  return computeDefaultValuesGeneric(fcrDPlanningConfigurations, initialData);
}
